// Lines dictionary Keyword
export const eyebrowKeyLineSpeicalOffers = 'cnhi-lineSpecialOffersEyebrow';
export const titleKeyLineSpeicalOffers = 'cnhi-lineSpecialOffersTitle';
export const descriptionKeyLineSpeicalOffers = 'cnhi-lineSpecialOffersDescription';

// Series dictionary keyword

export const titleKeySeriesFeature = 'cnhi-seriesFeaturesTitle';

export const titleKeyModelListing = 'cnhi-seriesModelsTitle';
export const eyebrowKeyModelListing = 'cnhi-seriesModelsEyebrow';
export const descriptionKeyModelListing = 'cnhi-seriesModelsDescription';

export const eyebrowKeySeriesSpeicalOffers = 'cnhi-seriesSpecialOffersEyebrow';
export const titleKeySeriesSpeicalOffers = 'cnhi-seriesSpecialOffersTitle';
export const descriptionKeySeriesSpeicalOffers = 'cnhi-seriesSpecialOffersDescription';

export const eyebrowKeySeriesCompatibleLoaders = 'cnhi-seriesCompatibleLoadersEyebrow';
export const titleKeySeriesCompatibleLoaders = 'cnhi-seriesCompatibleLoadersTitle';
export const descriptionKeySeriesCompatibleLoaders = 'cnhi-seriesCompatibleLoadersDescription';

export const eyebrowKeySeriesCompatibleAttachments = 'cnhi-seriesCompatibleAttachmentsEyebrow';
export const titleKeySeriesCompatibleAttachments = 'cnhi-seriesCompatibleAttachmentsTitle';
export const descriptionKeySeriesCompatibleAttachments = 'cnhi-seriesCompatibleAttachmentsDescription';

export const eyebrowKeySeriesBrochure = 'cnhi-seriesBrochureEyebrow';
export const titleKeySeriesBrochure = 'cnhi-seriesBrochureTitle';
export const descriptionKeySeriesBrochure = 'cnhi-seriesBrochureDescription';

export const eyebrowKeySeriesSpecifications = 'cnhi-seriesSpecificationsEyebrow';
export const titleKeySeriesSpecifications = 'cnhi-seriesSpecificationsTitle';
export const notesKeySeriesSpecifications = 'cnhi-seriesSpecificationsNotes';

export const eyebrowKeySeriesTestimonials = 'cnhi-seriesTestimonialsEyebrow';
export const titleKeySeriesTestimonials = 'cnhi-seriesTestimonialsTitle';
export const descriptionKeySeriesTestimonials = 'cnhi-seriesTestimonialsDescription';

// Models dictionary keyword

export const eyebrowKeyModelCompatibleLoaders = 'cnhi-modelCompatibleLoadersEyebrow';
export const titleKeyModelCompatibleLoaders = 'cnhi-modelCompatibleLoadersTitle';
export const descriptionKeyModelCompatibleLoaders = 'cnhi-modelCompatibleLoadersDescription';

export const eyebrowKeyModelCompatibleAttachments = 'cnhi-modelCompatibleAttachmentsEyebrow';
export const titleKeyModelCompatibleAttachments = 'cnhi-modelCompatibleAttachmentsTitle';
export const descriptionKeyModelCompatibleAttachments = 'cnhi-modelCompatibleAttachmentsDescription';
